import { i18n } from "@/i18n";

import { AGGREGATE_MATERIAL_LIST } from "../domain/constants";

export const getAggregateMaterialOptions = (hasNull?: boolean) => {
  const options = AGGREGATE_MATERIAL_LIST.map(item => ({
    label: i18n.t("add_new_job_drawer.bin_material_label", {
      material: item.material,
      unitPrice: item.unitPrice,
    }),
    value: item.material,
  }));
  if (hasNull) return [{ label: i18n.t("none"), value: "" }, ...options];
  return options;
};
